/* eslint-disable max-len */
import { useAccountStore } from "base/stores";
import { DataService } from "base/services";

import { CHANNEL_CONST } from "../utils/constant";

const LIST_OF_MEDIUM_WITH_POST = [CHANNEL_CONST.TEAM, CHANNEL_CONST.CHANNEL];

export const CommentService = {
  get accountDetails() {
    return useAccountStore.getState();
  },
  getBasePath(params) {
    if (params?.isEventComment) {
      return `/${params.medium}/2/${this.accountDetails._id}/event/${params.instanceId}`;
    } else {
      return LIST_OF_MEDIUM_WITH_POST.includes(params.medium?.toLowerCase())
        ? `/${CHANNEL_CONST.TEAM}/2/${this.accountDetails._id}/${params.teamId}/${CHANNEL_CONST.CHANNEL}/${params.mediumId}/${params.instanceType}/${params.instanceId}`
        : `/${params.medium}/2/${this.accountDetails._id}/${params.mediumId}/` +
            `${params.instanceType}/${params.instanceId}/${params.entityType}/${params.entityId}`;
    }
  },
  getReaction(params) {
    return DataService.get(
      `${this.getBasePath(params)}/${CHANNEL_CONST.REACTION}`
    );
  },
  postReaction(params) {
    return DataService.post(
      `${this.getBasePath(params)}/${CHANNEL_CONST.REACTION}`,
      { data: params.data }
    );
  },
  unlikeReaction(params) {
    return DataService.delete(
      `${this.getBasePath(params)}/${CHANNEL_CONST.REACTION}`
    );
  },
  getComment(params) {
    return DataService.get(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${params.commentId}`
    );
  },
  getComments(params) {
    return DataService.get(
      `/${CHANNEL_CONST.TEAM}/2/${this.accountDetails._id}/${params.teamId}/${CHANNEL_CONST.CHANNEL}/${params.mediumId}/${params.instanceType}/${params.instanceId}/${CHANNEL_CONST.COMMENT}/default`
    );
  },
  getCommentsBatch(params) {
    return DataService.post(
      `/${CHANNEL_CONST.TEAM}/2/${this.accountDetails._id}/${params.teamId}/${CHANNEL_CONST.CHANNEL}/${params.mediumId}/${CHANNEL_CONST.COMMENT}/default/batch`,
      {
        data: {
          post_ids: params.postIds
        }
      }
    );
  },
  getAllComments(params) {
    if (params?.isEventComment) {
      return DataService.get(
        `/${params.medium}/2/${this.accountDetails._id}/event/${params.instanceId}/${CHANNEL_CONST.COMMENT}`
      );
    } else {
      return LIST_OF_MEDIUM_WITH_POST.includes(params.medium?.toLowerCase())
        ? DataService.get(
            `/${CHANNEL_CONST.TEAM}/2/${this.accountDetails._id}/${params.teamId}/${CHANNEL_CONST.CHANNEL}/${params.mediumId}/${params.instanceType}/${params.instanceId}/${CHANNEL_CONST.COMMENT}`
          )
        : DataService.get(
            `/${params.medium}/2/${this.accountDetails._id}/${params.mediumId}/${params.instanceType}/${params.instanceId}/${CHANNEL_CONST.COMMENT}`
          );
    }
  },
  getGifUrl(params) {
    return DataService.get(
      `/${CHANNEL_CONST.POST}/2/${this.accountDetails._id}/gif_url`,
      {
        query: { url: params.text }
      }
    );
  },
  createComments(params, cb) {
    return DataService.postq(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}`,
      {
        data: params.data
      },
      cb
    );
  },
  updateComment(params) {
    return DataService.update(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }`,
      {
        data: params.data
      }
    );
  },
  deleteComment(params) {
    return DataService.delete(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${params.commentId}`
    );
  },
  postCommentReaction(params) {
    return DataService.post(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REACTION}`,
      { data: params.data }
    );
  },
  unlikeCommentReaction(params) {
    return DataService.delete(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REACTION}`
    );
  },
  getReply(params) {
    return DataService.get(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REPLY}/${params.replyId}`
    );
  },
  getReplyComments(params) {
    return DataService.get(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REPLY}`
    );
  },
  createReplycomment(params) {
    return DataService.post(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REPLY}`,
      {
        data: params.data
      }
    );
  },
  updateReply(params) {
    return DataService.update(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REPLY}/${params.replyId}`,
      {
        data: params.data
      }
    );
  },
  deleteReply(params) {
    return DataService.delete(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REPLY}/${params.replyId}`
    );
  },
  postReplyReaction(params) {
    return DataService.post(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REPLY}/${params.replyId}/${CHANNEL_CONST.REACTION}`,
      {
        data: params.data
      }
    );
  },
  unlikeReplyReaction(params) {
    return DataService.delete(
      `${this.getBasePath(params)}/${CHANNEL_CONST.COMMENT}/${
        params.commentId
      }/${CHANNEL_CONST.REPLY}/${params.replyId}/${CHANNEL_CONST.REACTION}`
    );
  },
  getMentionData(params) {
    let url = `/${CHANNEL_CONST.TEAM}/2/${this.accountDetails._id}/${params.teamId}/mentions`;
    if (params.medium === "process") {
      url = `/process/2/${this.accountDetails._id}/${params.mediumId}/${params.instanceId}/${CHANNEL_CONST.COMMENT}/users`;
    } else if (params.medium === "community") {
      url = `/${params.medium}/2/${this.accountDetails._id}/event/${params.instanceId}/mentions`;
    }
    return DataService.get(url, {
      query: { q: params.data, page_number: 1, page_size: 50 }
    });
  }
};
